import { Component, input, InputSignal, OnInit } from '@angular/core';
import { PopoverDirective } from 'ngx-bootstrap/popover';
import { AvailableBSPositions } from 'ngx-bootstrap/positioning';
import { WeissmanModalService } from '../../../Compliance/WeissmanModalService';
import { SharedPipesModule } from '../../../UI-Lib/Pipes/shared-pipes.module';
import { ActivityService } from '../activity.service';
import { ParcelActivitySummaryModalComponent } from './Parcel-Activity-Summary/parcel-activity-summary-modal.component';

import * as _ from 'lodash';

@Component({
    selector: 'activity-deadline-footer',
    templateUrl: './activityDeadlineFooter.component.html',
    imports: [PopoverDirective, SharedPipesModule],
})
export class ActivityDeadlineFooterComponent implements OnInit {
    constructor(
        private readonly _activityService: ActivityService,
        private readonly _weissmanModalService: WeissmanModalService,
    ) {}

    siteId: InputSignal<number> = input();
    parcelId: InputSignal<number> = input();
    isModal: InputSignal<boolean> = input();

    footerSections: any[] = [];
    popoverContent: any;
    onRow: number = 0;

    filterSections = (section, i: number): boolean => {
        return Math.floor(i / 3) === this.onRow;
    };

    async ngOnInit(): Promise<void> {
        const result = await this._activityService.getDeadlineData(this.siteId(), this.parcelId());

        this.footerSections = _.chain(result)
            .map((data, deadlineType) => {
                return { ...(data as any), ...{ deadlineType: deadlineType } };
            })
            .filter('date')
            .value();
    }

    deadlineDate(section): number {
        const sortVal = section.date === 'Pending' ? 0 : new Date(section.date).getTime();
        switch (section.deadlineType) {
            case 'appealHearing':
                return sortVal;
            case 'appealDeadline':
                return sortVal + 1;
            case 'paymentDeadline':
                return sortVal + 2;
            case 'complianceDeadline':
                return sortVal + 3;
            default:
                return sortVal;
        }
    }

    getDeadlineLabel(type: string): string {
        switch (type) {
            case 'appealHearing':
                return 'Next Appeal Hearing';
            case 'appealDeadline':
                return 'Next Appeal Deadline';
            case 'paymentDeadline':
                return 'Next Payment Deadline';
            case 'complianceDeadline':
                return 'Next Filing Deadline';
            default:
                return type;
        }
    }

    setPopoverContent(section): void {
        let label = '';
        switch (section.deadlineType) {
            case 'appealDeadline':
                label = 'Revision';
                break;
            case 'appealHearing':
                label = 'Appeal Level';
                break;
            case 'paymentDeadline':
                label = 'Collector';
                break;
            case 'complianceDeadline':
                label = 'Filing Description';
                break;
        }
        this.popoverContent = {
            label: label,
            data: section,
        };
    }

    getValue(year: any): any {
        const valArr = _.chain(year).omit('annualYear').values().compact().value();
        return valArr[0];
    }

    getPlacement(index: number): AvailableBSPositions {
        switch (index) {
            case 0:
                return 'top left';
            case 1:
                return 'top';
            case 2:
                return 'top right';
            default:
                return 'top';
        }
    }

    changeRow(): void {
        this.onRow = this.onRow ? 0 : 1;
        this.footerSections = [...this.footerSections];
    }

    async openModal(): Promise<void> {
        if (!this.parcelId()) {
            const params = {
                siteId: this.siteId(),
            };
            await this._weissmanModalService.showAsync(ParcelActivitySummaryModalComponent, params, 'modal-lg');
        }
    }
}
